// --- Nodes ---
export const extractNodes = (json) => {
  return json.map((node) => ({
    id: node.id,
    x_axis: node.x_axis,
    y_axis: node.y_axis,
    label: node.label,
    file_content: node.file_content,
    text_content: node.text_content,
  }));
};
